import { Injectable } from '@angular/core';
import { CrewbidApiService } from './crewbid-api.service';
import { AppConstants } from '../enums/global-enum-constant';
import { db } from "../utility/crewbid-db";

@Injectable({ providedIn: 'root' })
export class AppInitService {

  constructor(private ApiService: CrewbidApiService) {}

  async initApp(): Promise<void> {
    try {
      await db.open();

      const activePage = sessionStorage?.getItem('activePage') || '';
      const isLoaded = ['bidline', 'home'].includes(activePage);

      if (!isLoaded) {
        const fromApp = { FromApp: AppConstants.AppNum };

        const res: any = await this.ApiService
          .GetRestDataForPost('User/GetApplicationLoadDatas', fromApp)
          .toPromise();

        if (res?.IsSWAAPI) {
          localStorage.setItem('enableSwaApi', 'true');
        } else {
          localStorage.removeItem('enableSwaApi');
        }
      }
    } catch (err) {
      console.error('App initialization failed', err);
      return Promise.resolve();
    }
  }

}